import { SVC_A } from './base'
import { tagCamera, defaultTaggingRules, westchesterTaggingRules } from '@/libraries/util/normalizeData'

function loadDomainsAndCameras () {
  return SVC_A.post('/api/v4/domains')
}

export function getDNAEvents (dnaId, params) {
  return SVC_A.get(`/api/events/v1/dna/camera/${dnaId}`, params)
}

function mappedDataFromAPIResponse (data, currentDomainUUID, currentCameraUUID) {
  const mapped = {
    domains: {
      all: [],
      uuids: [],
      current: undefined,
      by: {
        uuid: {},
        cameraUUID: {},
      },
    },
    cameras: {
      all: [],
      uuids: [],
      by: {
        uuid: {}, // Map Camera IDs to the index of the camera for faster lookup by ID.
        domainUUID: {}, // Map domain IDs to the index of the camera...
      },
    },
  }

  if (!data.domains) {
    console.warn('No domains data in response payload. Responding with default empty object.')
    return mapped
  }

  data.domains.filter(domain => !domain.is_dead).forEach(function (domain) {
    const deflatedDomain = {
      'uuid': domain.uuid,
      'description': domain.description,
      'cameraUUIDs': domain.cameras.map(camera => camera.uuid),
      'preferences': domain.preferences,
    }

    mapped.domains.all.push(deflatedDomain)
    mapped.domains.uuids.push(deflatedDomain.uuid)
    mapped.domains.by.uuid[domain.uuid] = deflatedDomain

    domain.cameras.forEach(camera => {
      mapped.domains.by.cameraUUID[camera.uuid] = deflatedDomain
    })

    const cameras = updateCamerasFromDomain(mapped.cameras, domain)
    mapped.cameras = cameras
  }, this)

  // Note to self: Might be an issue with frontend building dropdown change. 6/18/18 - Moshe
  // mapped.domains.all = mapped.domains.all.sort(function (a, b) {
  //   const order = a.description.toLowerCase() > b.description.toLowerCase()
  //   return order
  // })

  if (mapped.domains.all.length) {
    const defaultCurrentDomain = mapped.domains.all[0]
    const previousCurrentDomain = mapped.domains.all.find(domain => domain.uuid === currentDomainUUID)

    // If there's a domain passed in (i.e. from the store, first set that.)
    if (previousCurrentDomain) {
      mapped.domains.current = previousCurrentDomain
    }

    // Next, if there's a camera that's active, update domain based on camera.
    if (currentCameraUUID) {
      mapped.domains.current = mapped.domains.by.cameraUUID[currentCameraUUID]
    }

    // If there's neither, default to first domain.
    if (!mapped.domains.current) {
      mapped.domains.current = defaultCurrentDomain
    }
  }

  return mapped
}

/**
 * Builds a map for cameras by domain and id.
 *
 * @param {Object} domain The domain from which to map cameras.
 * @param {Object} cameras A cameras map, which may be partially populated.
 * @returns An updated cameras map.
 */
function updateCamerasFromDomain (cameras, domain = {}) {
  const westchesterDomain = '' // TODO: Fill this in. - Moshe 6/18/18
  const taggingRules = domain.uuid === westchesterDomain ? westchesterTaggingRules : defaultTaggingRules

  domain.cameras.forEach(function (camera) {
    cameras.by.uuid[camera.uuid] = camera
    tagCamera(camera, taggingRules)
  })

  cameras.all = cameras.all.concat(domain.cameras)
  cameras.uuids = cameras.uuids.concat(domain.cameras.map(camera => camera.uuid))
  cameras.by.domainUUID[domain.uuid] = domain.cameras

  return cameras
}

export { loadDomainsAndCameras, mappedDataFromAPIResponse }
